import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Loader2, Lock, Building2 } from 'lucide-react';

const VerifyPasswordPage = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { companyName, verifyUserPassword, logout } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const valid = await verifyUserPassword(password);
    if (valid) {
      navigate('/dashboard');
    } else {
      setError('Λάθος κωδικός χειριστή');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 p-4">
      <div className="w-full max-w-md animate-in fade-in-0 zoom-in-95 duration-500">
        <div className="text-center mb-8">
          <div className="inline-block p-4 bg-emerald-600 rounded-2xl shadow-xl shadow-emerald-600/20 mb-4">
            <Building2 className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-1" data-testid="company-name-header">{companyName}</h1>
          <p className="text-blue-300/70 text-sm">Εισάγετε τον κωδικό χειριστή</p>
        </div>

        <Card className="shadow-2xl border-0 bg-white/95 backdrop-blur">
          <CardHeader className="pb-4">
            <CardTitle className="text-xl text-center">Κωδικός Χειριστή</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    data-testid="verify-password-input"
                    type="password"
                    placeholder="Κωδικός χειριστή"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="pl-10"
                    required
                    autoFocus
                    disabled={loading}
                  />
                </div>
              </div>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm" data-testid="verify-error">
                  {error}
                </div>
              )}

              <Button data-testid="verify-submit" type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700 h-11 text-base" disabled={loading}>
                {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Επαλήθευση...</> : 'Είσοδος'}
              </Button>
              <Button type="button" variant="ghost" className="w-full text-gray-500" onClick={logout} data-testid="verify-back">
                Αλλαγή εταιρίας
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default VerifyPasswordPage;
